import {queryOptions} from '@tanstack/react-query';
import {api} from '@/libs/baseApi.client';
import type {ActionType} from '../type/action';

export const actionTypesOptions = () =>
  queryOptions({
    queryKey: ['action-types'],
    queryFn: async () => {
      try {
        const response = await api.get<ActionType[]>('/actions/action-types');

        return response.data;
      } catch (error) {
        console.error('Failed to fetch actions:', JSON.stringify(error));
        return [];
      }
    },
    // Добавляем настройки для лучшей работы с SSG
    staleTime: 5 * 60 * 1000, // 5 минут
    retry: 1, // Только одна попытка повтора
  });
